import classNames from "classnames";
import {Fragment, useState} from "react";

import {Loader, Switch} from "components";
import {useAppDispatch, useAppSelector} from "hooks";
import {
	clearAnonymiseProfiles,
	setAnonymiseProfiles,
	toggleAnonymiseProfileTurnOn,
} from "store/candidate/candidateActions";
import {anonymiseProfileModeTurnedOnSelector} from "store/candidate/candidateSelectors";

import styles from "./Sidebar.module.scss";

type TAnonymiseProfilesProps = {
	expanded: boolean;
};

const AnonymiseProfiles = ({expanded}: TAnonymiseProfilesProps) => {
	const dispatch = useAppDispatch();
	const anonymiseProfileModeTurnedOn = useAppSelector(anonymiseProfileModeTurnedOnSelector);
	const [isAnonymisingLoading, setIsAnonymisingLoading] = useState<boolean>(false);

	const handleToggleAnonymiseProfileTurnOn = async () => {
		if (anonymiseProfileModeTurnedOn) {
			dispatch(toggleAnonymiseProfileTurnOn(false));
			dispatch(clearAnonymiseProfiles());
		} else {
			setIsAnonymisingLoading(true);

			try {
				const response = await fetch("/get-anonymised-profiles-data.json");
				const data = await response.json();

				dispatch(setAnonymiseProfiles(data));
				dispatch(toggleAnonymiseProfileTurnOn(true));
			} catch (e) {
				console.error("Failed to load anonymised profiles", e);
			} finally {
				setIsAnonymisingLoading(false);
			}
		}
	};

	return (
		<Fragment>
			<div
				role="button"
				className={classNames(styles.navItems__footer__info, {
					[styles.navItems__footer__info_close]: !expanded,
				})}
			>
				{isAnonymisingLoading ? (
					<Loader width={20} height={20} />
				) : (
					<Switch
						checked={anonymiseProfileModeTurnedOn}
						onChange={handleToggleAnonymiseProfileTurnOn}
					/>
				)}
				{expanded && (
					<p className={styles.navItems__footer__info_text}>Anonymise Profiles</p>
				)}
			</div>

			<div className={styles.navItems__footer__solid} />
		</Fragment>
	);
};

export default AnonymiseProfiles;
